import React from 'react'
import { useForm } from 'react-hook-form';
import DemoPage from './DemoPage';

const Subscribe = () => {

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm();


    const onSubmit = (data) => {
    };

    return (
        <div className='subscribe-us'> 
            <div className='subscribe-us-container'>
                <div className='subscribe-us-form-desc'>
                    <div className='subscribe-left'>
                        <h3 className="subscribe-title">Ready to get
                            everything you need <br/>
                            to <span style={{color:"rgba(45, 118, 253, 1)"}}>hire better</span>?</h3>
                            <DemoPage/>
                    </div>
                    <div className='subscribe-right'>
                        <h4>Modern Recruiter newsletter</h4>
                        <p style={{width:"70%"}}>Our bi-weekly newsletter full of inspiration,
                            podcasts, trends and news.</p>
                        <form className="subscribe-us-form" onSubmit={handleSubmit(onSubmit)}>
                            <div className="subscribe-us-form-group">
                                <label htmlFor="email" className="subscribe-us-form-label">
                                    Email address <span style={{ color: "red" }}>*</span>
                                </label>
                                <input
                                    type="email"
                                    id="email"
                                    placeholder="Enter your email"
                                    className={`subscribe-us-form-input ${errors.email ? 'subscribe-input-error' : ''}`}
                                    {...register("email", {
                                        required: "Email is required",
                                        pattern: { value: /^\S+@\S+\.\S+$/, message: "Invalid email format" },
                                    })}
                                />
                                {errors.email && <p className="subscribe-error-message">{errors.email.message}</p>}
                            </div>

                            <button type="submit" className="subscribe-us-submit-button">
                                Subscribe
                            </button>
                        </form>
                        <p className='home-page-choose-language'>Choose your language</p>
                        <select className='language-select-home-page'>
                            <option value="English(US)">English(US)</option>
                            <option value="Hindi">Hindi</option>
                        </select>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default Subscribe